var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7168 12C13.0305 12 15.7168 9.31371 15.7168 6C15.7168 2.68629 13.0305 0 9.7168 0C6.40309 0 3.7168 2.68629 3.7168 6C3.7168 9.31371 6.40309 12 9.7168 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7168 14C4.74852 14.0055 0.722328 18.0317 0.716797 23C0.716797 23.5523 1.1645 24 1.71678 24H17.7168C18.269 24 18.7167 23.5523 18.7167 23C18.7113 18.0317 14.6851 14.0055 9.7168 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.d59d35813a6c9ee22b835ca4c69a0c31.svg";
export { ForwardRef as ReactComponent };